import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from 'src/app/services/seo.service';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';


export interface instructor {
  categorias: string[];
  descripcion: string;
  email: string;
  empresaDescripcion: string;
  empresaFoto: string;
  empresaId: string;
  empresaNombre: string;
  empresaResumen: string;
  enlaceLinkedin: string;
  fechaCreacion: Date;
  foto: string;
  fotoFondo: string;
  instructorResumen: string;
  nombre: string;
  resumen: string;
  sitioWeb: string;
}

export interface cursoInstructor{
  foto: string;
  titulo: string;
  resumen: string;
  precioFinal: number;
  id: string;
}

@Component({
  selector: 'app-detalle-instructor',
  templateUrl: './detalle-instructor.component.html',
  styleUrls: ['./detalle-instructor.component.css']
})
export class DetalleInstructorComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private afs: AngularFirestore,
    private shared: RoutingVariablesService,
    private router: Router,
    private seo: SeoService,
  ) { }

  id = this.route.snapshot.paramMap.get('id');
  instructor: instructor;
  cursosInstructor: cursoInstructor[] = [];
  loaded: number = 0;

  ngOnInit() {
    this.cargarInstructor();
  }
  
  cargarInstructor() {
    this.afs.collection('instructores').doc(this.id).ref.get().then(snap => {
      const instructor = snap.data();
      this.instructor = {
        categorias: instructor['categorias'],
        descripcion: instructor['descripcion'],
        email: instructor['email'],
        empresaDescripcion: instructor['empresaDescripcion'],
        empresaFoto: instructor['empresaFoto'],
        empresaId: instructor['empresaId'],
        empresaNombre: instructor['empresaNombre'],
        empresaResumen: instructor['empresaResumen'],
        enlaceLinkedin: instructor['enlaceLinkedin'],
        fechaCreacion: instructor['fechaCreacion'],
        foto: instructor['foto'],
        fotoFondo: instructor['fotoFondo'],
        instructorResumen: instructor['instructorResumen'],
        nombre: instructor['nombre'],
        resumen: instructor['resumen'],
        sitioWeb: instructor['sitioweb'],
      }
    }).then(() => {
      this.seo.generateTags({
        title: this.instructor.nombre,
        description: this.instructor.descripcion,
        image: this.instructor.foto
      })
      this.afs.collection('cursos').ref.where('instructorId', '==', this.id).get().then(response => {
        response.docs.forEach(doc => {
          const data = doc.data();
          const curso: cursoInstructor = {
            foto: data['foto'],
            titulo: data['titulo'],
            resumen: data['resumen'],
            precioFinal: data['precioFinal'],
            id: doc.id,
          }
          if (doc.data()['publicado']){
            this.cursosInstructor = this.cursosInstructor.concat(curso);
          }
          this.loaded = 1;
        });
      }).catch(error => {
        console.log(error)
      })
    }).catch(error => {
      console.log(error)
    })
  }

  regresarInstructores() {
    const obj = { tipoBusqueda: "instructores"};
    this.shared.pushData(obj);
    this.router.navigate(['/buscar']);
  }
}


